import type { Editor as TipTapEditor } from '@tiptap/react';
import { createContext } from 'react';

interface EditorContextType {
  editor: TipTapEditor;
}

export const EditorContext = createContext<EditorContextType>({} as EditorContextType);

export type EditorProviderProps = Pick<EditorContextType, 'editor'> & {
  children: React.ReactNode;
};

export function EditorProvider({ children, editor }: EditorProviderProps) {
  return <EditorContext value={{ editor }}>{children}</EditorContext>;
}
